type AppSideNav = {
  element: HTMLElement | null;
  init: () => void;
};

const AppSideNav: AppSideNav = {
  element: document.querySelector('[data-hook=appSideNav]') as HTMLElement | null,

  init() {
    if (!this.element) return;

    // const options = this.element.dataset.options ? JSON.parse(this.element.dataset.options) : {};
    let options: any = {};
    if (this.element.dataset.options) {
      try {
        options = JSON.parse(this.element.dataset.options);
      } catch {
        options = {};
      }
    }

    const xlBreakpoint = 1200;
    let observer: IntersectionObserver | null = null;
    const getHeaderOffset = () => Math.max(window.innerHeight - 120, 0);
    const createObserver = () => {
      const headerOffset = getHeaderOffset();
      return new IntersectionObserver(
        (entries: IntersectionObserverEntry[]) => {
          entries.forEach((entry) => {
            if (!this.element) {
              return;
            }
            if (entry.isIntersecting) {
              this.element.classList.add('is-pinned');
              this.element.style.height = `${headerOffset}px`;
            } else {
              this.element.classList.remove('is-pinned');
              this.element.style.height = 'initial';
            }
          });
        },
        {
          rootMargin: `-100px 0px -${headerOffset}px 0px`,
          threshold: 0,
        },
      );
    };
    const syncObserver = () => {
      if (!this.element) {
        return;
      }
      observer?.disconnect();
      observer = null;
      if (window.innerWidth >= xlBreakpoint) {
        // Trigger this on the XL breakpoint and above
        observer = createObserver();
        observer.observe(this.element);
      } else {
        this.element.classList.remove('is-pinned');
        this.element.style.height = 'initial';
      }
    };
    syncObserver();
    window.addEventListener('resize', syncObserver);

    const appSideNavButtons = this.element.querySelectorAll('button');
    appSideNavButtons?.forEach((button) => {
      const sideNavButton = button as HTMLButtonElement;
      const sideNavButtonTextWrapper = sideNavButton.querySelector('span');

      sideNavButton.addEventListener('click', () => {
        const newState = sideNavButton.getAttribute('aria-expanded') === 'true' ? 'false' : 'true';
        sideNavButton.setAttribute('aria-expanded', newState);
        if (sideNavButtonTextWrapper) {
          if (newState === 'true') {
            sideNavButtonTextWrapper.innerText = options?.microcopy?.menu?.close ?? 'Close';
          } else {
            sideNavButtonTextWrapper.innerText = options?.microcopy?.menu?.open ?? 'Open';
          }
        }
      });
    });
  },
};
export default AppSideNav;
